import React from "react";
import { withStyles } from "@material-ui/core";
/*
 * This is a component that is used to render the text information
 * of the farol.
 * title: string
 * properties: object of arrays values
 * * example:{ "name": ["Farol 1"], "description": ["Farol 1 description"] }
 */

const DataInfo = (innerProperties) =>
  Object.keys(innerProperties).map((key, index, keys) => {
    const values = innerProperties[key].join(", ");

    const endSpace = keys.length - 1 === index ? <br /> : "";

    if (key[0] === "_") {
      return (
        <span key={values}>
          {values}
          <br />
        </span>
      );
    }

    return (
      <span key={values}>
        <b>{key}</b>: {values}
        <br />
        {endSpace}
      </span>
    );
  });

const TextInfoFarol = ({ title, properties, titleAdornmentColor, classes }) => {
  const Info = properties.length
    ? properties.map((innerPropertie) => DataInfo(innerPropertie)).flat()
    : DataInfo(properties);

  return (
    <span className={classes.content}>
      <span className={classes.title}>
        {titleAdornmentColor && (
          <div
            className={classes.titleAdornment}
            style={{
              backgroundColor: titleAdornmentColor,
            }}
          />
        )}
        <b>{title}</b>
      </span>
      <br />
      {Info.map((info) => info)}
    </span>
  );
};

const styles = () => {
  return {
    content: {
      flexDirection: "column",
      display: "flex",
      textAlign: "left",
    },
    title: {
      display: "flex",
      alignItems: "center",
    },
    titleAdornment: {
      width: "10px",
      height: "10px",
      margin: "2px",
      borderRadius: "50%",
    },
  };
};

export default withStyles(styles)(TextInfoFarol);
